module.exports = __webpack_public_path__ + "628a2458072558313dd9c0063ee2adaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1/public/team/Leadership_Greg.jpg
// module id = 361
// module chunks = 0